

import { LocationCardProps, LocationMapping } from "pages/HomePage/data/HomePage.type";
import apiHandler from "../apiHandler";
import { DiscountFactorModel } from "pages/Settings/DiscountFactor/data/DiscountFactorModel";
import { LocationModel } from "object-models/location-model";

export const _getLocations = async () => {
  return apiHandler.get<Array<LocationCardProps>>(
    "EssentialLocationsDetails/"
  );
};

export const _getLocationNames = async () => {
  return apiHandler.get<Array<LocationMapping>>(
    "locationNames"
  );
};

export const _IsLocationExist = async (locationName: string) => {
  return apiHandler.get<boolean>(
    "LocationExist/"+locationName
  );
};

export const _addLocation = async (location: LocationModel) => {
  return apiHandler.post<LocationModel>("location", location);
};

export const _updateLocation = async (location: LocationModel) => {
  return apiHandler.put<LocationModel>("updatelocation", location);
};

export const _getLocation = async (byId: number) => {
  return apiHandler.get<LocationModel>("location/" + byId);
};
export const _deleteLocation = async (locationId: number) => {
  return apiHandler.delete("location/" + locationId);
};

export const _updatediscountfactor = async (location: DiscountFactorModel) => {
  return apiHandler.patch<DiscountFactorModel>("updatediscountfactor", location);
};

export const _downloadLocationTemplate = async (locationId: number): Promise<Blob | undefined> => {
  return apiHandler.get<Blob>(
    `location/${locationId}/template`,
    "blob"
  );
};